<script>
  import * as Constants from '../Constants';
  import * as Utils from '../services/Utils';
  import { _ } from '../services/i18n';

  // Item
  // import Modal from '../components/Modal.svelte';
  import { getContext } from 'svelte';
  const { open } = getContext('simple-modal');
  import GalleryGraphicsItem from './GalleryGraphicsItem.svelte';
  
  let items = [];
  let loading = false;
  let error = false;
  const GALLERY_GRAPHICS_TYPES_KEYS = Object.keys(Constants.GALLERY_GRAPHICS_TYPES);

  function fetchItems() {
    loading = true;
    Utils.fetchData(Constants.HOST_SERVICES + 'getGraphicsNg')
        .then(response => response.json())
        .then(response => items = response.result.items)
        .catch(error => {
          error = true;
          console.error(error);
        })
        .finally(() => {
          loading = false;
        });
  }
  
  fetchItems();

	const showItem = (name) => {
		open(GalleryGraphicsItem, { name: name });
	};
</script>

<!-- HTML ----------------------------------------------------------------------->
<div id="container" class="fadeIn def_back gallery-grahics">
  <h2 id="graphics-title" class="titles">
    {$_('menu.sezGraphics')}
  </h2>

  {#each GALLERY_GRAPHICS_TYPES_KEYS as TYPE}
    <div class="graphic_sezs {TYPE}">
      <div class="graphic_headers">
        <div class="titles-div">
          <h3 class="titles">
            <i class="fas fa-2x fa-{Constants.GALLERY_GRAPHICS_TYPES[TYPE]}"></i>
            {TYPE}
          </h3>
        </div>
        <p class="desc"></p>
      </div>
      
      {#if loading}
      <!-- thumbs[TYPE].length === 0 && !galleryError -->
        <div class="lds-css">
          <div class="lds-eclipse"><div></div></div>
        </div>
        
      {:else if items}
        <ul class="thumbs">
          {#each items[TYPE] as elem}
            <li class="item {elem.type.toLowerCase()}">
              <span on:click={showItem(elem.name)} rel="{elem.type}_group">
                <span class="imgDownload">
                  <img id="{elem.name}" alt="{elem.name}" width="180px" height="180px" class="{elem.type}"
                      src="{Constants.PUBLIC_GRAPHICS_IMAGES + elem.name + Constants.GALLERY_MIN_FILE_EXT}">
                </span>
              </span>
              <p class="graphic_descs def_back">{@html elem.title_en}</p>
            </li>
          {/each}
        </ul>

      {:else if error}
        <div class="gallery-error">
          <i class="far fa-times-circle"></i>
          {$_('errors.UNKNOWN')}
        </div>
      {/if}
    </div>
  {/each}
</div>


<!-- STYLES ----------------------------------------------------------------------->
<style type="text/scss">
@import '../../public/styles/variables';
@import '../../public/styles/mixins';

$graphics-transp-amount: 0.9;

#container {
  .graphic_sezs {
    margin: 0 -10px;
    &.render {
      .titles { color: lighten($idro-gallery-render, 35%); }
      background-color: transparentize($idro-gallery-render, $graphics-transp-amount);
    }
    &.video {
      .titles { color: lighten($idro-gallery-video, 15%); }
      background-color: transparentize($idro-gallery-video, $graphics-transp-amount);
    }
    &.other {
      .titles { color: lighten($idro-gallery-other, 35%); }
      background-color: transparentize($idro-gallery-other, $graphics-transp-amount);
    }
  }
  .graphic_headers {
    margin-top: 35px;
    text-align: center;
  }
  p.graphic_descs {
    text-align: center;
    width: 180px;
    padding: 3px;
    margin: 0 auto;
    box-sizing: border-box;
 }
  div.titles-div {
    i {
      margin: 0 0 5px;
    }
    span {
      margin: 16px 5px;
    }
  }

  .thumbs {
    .item {
      display: inline-block;
      margin: 0 16px 18px;
      > span {
        cursor: pointer;
      }
      img {
        border: 1px solid $idro-palette-first;
        @include box-shadow(0 0 10px 0 $idro-palette-black);
        @include transition(all 0.2s ease-in-out);
        &:hover {
          @include box-shadow(0 20px 5px 3px transparentize($idro-palette-black, 0.85));
          // @include box-shadow(0 0 20px 2px $idro-palette-black);
        }
        &.render { border-color: $idro-gallery-render; }
        &.video { border-color: $idro-gallery-video; }
        &.other { border-color: $idro-gallery-other; }
      }
    }
    a.rs {
      display: block;
      outline: none;
      z-index: 50;
      width: 42px;
      height: 42px;
      position: absolute;
      top: 52%;
      margin-top: -34px;
      text-shadow: 0 2px 20px #000;
      color: $idro-palette-highlighted;
      &:hover {
        color: $idro-palette-third;
      }
      &.leftRs {
        left: 0;
        &:hover {
        }
      }
      &.rightRs {
        right: 0;
        &:hover {
        }
      }
    }
  }

  span.downloadContainer {
    background-image: $background-light;
    position: absolute;
    bottom: 22px;
    right: 0;
    width: 82px
  }

  span.downloadText {
    display: block;
    padding: 2px 0 1px;
    color: #effaff
  }

  a.linkDownload {
    display: none;
    width: 75px;
    margin: 4px 0 0;
    padding: 3px;
    color: #ffffff;
    font-weight: bolder;
    border: 1px solid $idro-palette-first;
  }

  /** MOBILE */
  @media #{$mobile} {
    div.titles-div span {
      width: 66px;
    }
  }

  /** LITTLE PC */
  @media #{$tablet} {
    .thumbs a.rs {
      &.leftRs { left: 2px; }
      &.rightRs { right: 2px; }
    }
  }
  @media #{$tablet-s} {
    div.titles-div span {
      width: 66px;
    }
  }
}
</style>
